import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';

// Hysteresis: compact after scrolling past ENTER, expand again only above LEAVE, so it can't flicker at one threshold
const COMPACT_ENTER_Y = 64;
const COMPACT_LEAVE_Y = 16;

// Sticky wrapper for the profile hero. It owns the scroll/compact state, so scrolling re-renders only
// the hero and never the rest of the profile page (which embeds the device table).
const ProfileHeroSlot = ({children}) => {
    const [isCompact, setIsCompact] = useState(false);
    const [slotHeight, setSlotHeight] = useState(null);
    const heroRef = useRef(null);

    useEffect(() => {
        // React skips the re-render when the flag doesn't change, so checking on every scroll is cheap
        const handleScroll = () => {
            const y = window.scrollY;

            setIsCompact((compact) => (
                compact ? y > COMPACT_LEAVE_Y : y > COMPACT_ENTER_Y
            ));
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll, {passive: true});

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // The slot keeps the expanded hero's height, so shrinking the hero never shifts the page under it
    useLayoutEffect(() => {
        const hero = heroRef.current;

        if (!hero || isCompact) {
            return undefined;
        }

        const measure = () => setSlotHeight(hero.offsetHeight);

        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(hero);

        return () => observer.disconnect();
    }, [isCompact]);

    return (
        <div className="profile-hero-slot" style={{height: slotHeight || undefined}}>
            <header ref={heroRef} className={`profile-hero${isCompact ? ' profile-hero--compact' : ''}`}>
                {children}
            </header>
        </div>
    );
};

export default ProfileHeroSlot;
